// Client\client-vite\src\components\Sidebars\PublicSidebar.tsx
import {
    Home,
    Megaphone,
    Store,
    Cable,
    LineChart,
    Briefcase,
    Newspaper,
    User2,
    VideotapeIcon,
    NewspaperIcon,
    Banknote,
    Car,
} from "lucide-react";
import { Sidebar, SidebarContent, SidebarFooter, SidebarGroup, SidebarGroupContent, SidebarGroupLabel, SidebarHeader, SidebarMenu, SidebarMenuButton, SidebarMenuItem, SidebarSeparator } from "../ui/sidebar";
import { DropdownMenu, DropdownMenuTrigger } from "../ui/dropdown-menu";
import { Link } from "react-router-dom";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";

export const PublicSidebar = () => {

    const items = [
        { title: "Home", url: "/", icon: Home },
        { title: "Dealers", url: "/dealer", icon: Car },
        { title: "Customers", url: "/customer", icon: User2 },
        { title: "Auctions", url: "/auctions", icon: Megaphone },
        { title: "Marketplaces", url: "/marketplaces", icon: Store },
        { title: "Integrations", url: "/integrations", icon: Cable },
        { title: "Insurance", url: "/insurance", icon: LineChart },
        { title: "Warranty", url: "/warranty", icon: Briefcase },
        { title: "Lenders", url: "/lenders", icon: Banknote },
        { title: "News", url: "/news", icon: Newspaper },
        { title: "Blog", url: "/blog", icon: NewspaperIcon },
        { title: "Video", url: "/video", icon: VideotapeIcon },
    ];



    return (
        
        <Sidebar collapsible="icon">
            {/* HEADER WITH AVATAR */}
            <SidebarHeader className="py-2 px-8 flex items-center justify-center">
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <Avatar
                            className={`
                                cursor-pointer transition-all duration-200
                                rounded-none h-8 w-14
                                size-13
                                group-data-[collapsed]/sidebar:size-18
                            `}
                        >
                            <AvatarImage src="images/logo.png" className="object-contain" />
                            <AvatarFallback>IDS</AvatarFallback>
                        </Avatar>
                    </DropdownMenuTrigger>
                </DropdownMenu>
            </SidebarHeader>

            <SidebarSeparator />

            {/* CONTENT */}
            <SidebarContent className="flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-muted-foreground/40 hover:scrollbar-thumb-muted-foreground/70">
                <SidebarGroup>
                    <SidebarGroupLabel className="px-5 mb-4 text-xs uppercase tracking-wide text-muted-foreground">
                        Systems On Go!
                    </SidebarGroupLabel>
                    <SidebarGroupContent>
                        <SidebarMenu className="space-y-4 pb-4">
                            {items.map((item) => (
                                <SidebarMenuItem key={item.title}>
                                    <SidebarMenuButton asChild>
                                        <Link to={item.url}>
                                            <item.icon className="h-5 w-5" />
                                            <span>{item.title}</span>
                                        </Link>
                                    </SidebarMenuButton>
                                </SidebarMenuItem>
                            ))}
                        </SidebarMenu>
                    </SidebarGroupContent>
                </SidebarGroup>
            </SidebarContent>

            <SidebarSeparator />

            {/* FOOTER */}
            <SidebarFooter className="border-t border-border">
                <SidebarMenu>
                    <SidebarMenuItem>
                        <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                                <SidebarMenuButton>
                                    <User2 /> Join Our Newsletter
                                </SidebarMenuButton>
                            </DropdownMenuTrigger>
                        </DropdownMenu>
                    </SidebarMenuItem>
                </SidebarMenu>
            </SidebarFooter>
        </Sidebar>

    )
}



export default PublicSidebar